import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import { env } from 'env';
import Application from 'pages/Application';
import AuthProvider from 'shared/providers/AuthProvider';
import * as serviceWorker from './serviceWorker';
import { Provider as ReduxProvider } from 'react-redux';
import { persistor, store } from 'state/store';
import { PersistGate } from 'redux-persist/integration/react';
import 'assets/css/global.css';
import 'tippy.js/dist/tippy.css';
import { logOtto } from 'otto';
import { updateTabName } from 'updateTabName';
import ApolloProvider from 'shared/providers/ApolloProvider';
import TrackingProvider from 'shared/providers/TrackingProvider';

TagManager.initialize({
  gtmId: env.REACT_APP_TAG_MANAGER_ID || '',
});

updateTabName();
logOtto();

ReactDOM.render(
  <ReduxProvider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <AuthProvider>
        <ApolloProvider>
          <TrackingProvider>
            <Application />
          </TrackingProvider>
        </ApolloProvider>
      </AuthProvider>
    </PersistGate>
  </ReduxProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
